import React from 'react';
import {AnyCustomModelJson} from "../../api/json/CustomModelJson"
import {Button, Tooltip, Typography} from "@mui/material"
import {Link as RouterLink} from "react-router-dom"
import {ScoringMethod} from "../../api/enum/ScoringMethod"
import {ProjectJson} from "../../api/json/ProjectJson"

function ModelScoreCell({project, model}: { project: ProjectJson, model: AnyCustomModelJson }) {
    if (project.stats.numberOfValidationRows === 0) {
        return (
            <Tooltip title="Requires validation rows.">
                <Typography variant="body2">N/A</Typography>
            </Tooltip>
        )
    }

    if (true) {
        if(model.completed === null) {
            return <></>
        }

        if (model.failed) {
            return (
                <Tooltip title="Fine-tune failed.">
                    <Typography variant="body2">N/A</Typography>
                </Tooltip>
            )
        }
    }


    if (model.qualityCheck.completed === null) {
        return <Typography variant="body2">In progress</Typography>
    }

    if (model.qualityCheck.stats.completedTestRuns > model.qualityCheck.stats.scoredTestRuns) {
        return (
            <Button component={RouterLink} to={`/projects/${project?.id}/${true ? "custom-models" : "models"}/${model.id}`}
                    variant="outlined"
                    size="small"
            >
                Review
            </Button>
        )
    }

    return (
        <>
            <Typography>{model.qualityCheck.stats ? `${Math.round(model.qualityCheck.stats.score * 10) / 10}%` : ""}</Typography><br/>
            {project?.qualityCheckSettings.scoringMethod === ScoringMethod.EXACT_MATCH &&
                <Typography variant="caption">
                    {Math.round(model.qualityCheck.stats.score / 100 * model.qualityCheck.stats.completedTestRuns)} of {model.qualityCheck.stats.completedTestRuns}
                </Typography>
            }
        </>
    );
}

export default ModelScoreCell;